import MetricsModal from './MetricsModal.vue'

export default MetricsModal



// WEBPACK FOOTER //
// ./client/masteradmin/components/MetricsModal/index.js